export const REVERIFICATION_ROOT_ROUTE = 'account/reverification'

const withRoot = (path: string) => `/${REVERIFICATION_ROOT_ROUTE}${path}`
export const routes = {
  introStep: `/${REVERIFICATION_ROOT_ROUTE}`,
  todo: withRoot('/todo'),
} as const
